{
    "ShowHeaderRowLabel": "Mostra riga di intestazione:",
    "ShowFooterRowLabel": "Mostra riga piè di pagina:",
    "ShowContentRowsLabel": "Mostra righe di contenuto:",
    "ShowSpacerRowsLabel": "Mostrare le righe distanziatrici:",
    "NAME": "ReportContentRowsSettingsLanguage"
}